import React, { useState, useEffect } from 'react'
import styles from './index.module.css'
import {connect} from 'react-redux';
import {getScholarshipSettings, getGrantsYears, getScholarshipLevels, getGrantsTerms, getGrantsOptions, editGrantsOptions, addScholarshipSettings, editScholarshipSettings, getScholarshipTree} from '../../../actions/grants'
import Selector from '../../shared/Selector';
import moment from 'moment';
import { store } from '../../App';
import { GRANTS_OPTIONS } from '../../../actions/types';
import Loader from 'react-loader';
import { createNotification } from '../../notifications/notifications';
import { educationLevelsReNames } from '../../../utils/const';
import GrantThree from '../GrantThree';

const mapStateToProps = ({grants}) => {
    const {grant_types_loading, years, scholarshipLevels, scholarshipLevelsLoading, terms, scholarshipSettings, scholarshipTree, scholarshipTreeLoading} = grants
    return {grant_types_loading, years, scholarshipLevels, scholarshipLevelsLoading, terms, scholarshipSettings, scholarshipTree, scholarshipTreeLoading} 
}

const dateFormat = 'YYYY-MM-DD'

const Index = ({
    grant_types_loading,
    id, 
    setIsPopup,
    getScholarshipSettings,
    getGrantsYears,
    years,
    scholarshipLevels,
    scholarshipLevelsLoading,
    getScholarshipLevels,
    scholarshipSettings,
    terms,
    getGrantsTerms,
    editGrantsOptions,
    addScholarshipSettings,
    editScholarshipSettings,
    scholarshipTree, 
    scholarshipTreeLoading,
    getScholarshipTree
}) => {
  
    const [yearsLocal, setYearsLocal] = useState([]) // список годов
    const [year, setYear] = useState(null) // выбранный год
    const [optionsLocal,
            setOptionsLocal] = useState(null);
        const [isTermPopup,
            setIsTermPopup] = useState(null) ;

    const handleClose = () => { 
        setIsPopup(false)
    }

    const handleSubmit = () => {
            const newOptionsLocal = [...optionsLocal];

            const newOptions = newOptionsLocal.map(el => ({
                ...el,
                trmids: el?.trmids?.filter(trm => trm.isChecked === true)}));
    
            if (newOptions.find(el => el?.date_from == null) || newOptions.find(el => el?.date_from == ''))  return createNotification('error', 'Заполните поля "Дата от"');
            if (newOptions.find(el => el?.trmids && el?.trmids?.length == 0)) return createNotification('error', 'Выберите хотя бы один триместр для уровней образования');
    
            setIsPopup(false);
            if (newOptions.find(el => typeof el?.id != 'string')) {
                editScholarshipSettings(newOptions, year, id);
            } else {
                addScholarshipSettings(newOptions, year, id);
            }
            store.dispatch({type: GRANTS_OPTIONS, payload: []});
            setOptionsLocal(null);
        }

    useEffect(() => {
        getGrantsYears();
    }, [])

    useEffect(() => {
        if (!years) {
            return
        }
        const newYears = years
            ?.map(({name, xp_key}) => ({name, value: xp_key})).reverse()
        setYearsLocal([...newYears])
    }, [years])

    useEffect(() => {
            if (!yearsLocal || yearsLocal
                ?.length === 0) {
                return
            }
            const yearNow = moment()
                .year()
                .toString();
            const yearCurrent = yearsLocal
                ?.find((val) => val.name?.startsWith(yearNow))
                    .value
                    .toString();
            setYear(yearCurrent || '0')
        }, [yearsLocal])

    useEffect(() => {
        if (!year) return
        getScholarshipTree(year);
    }, [year])

    useEffect(() => {
        if (!year) return
        getScholarshipSettings(year, id);
    }, [year])

    useEffect(() => {
        getScholarshipLevels();
    }, [])

    useEffect(() => {
            const close = (e) => {
                if (e.keyCode === 27) {
                    handleClose();
                }
            }
            window.addEventListener('keydown', close)
            return () => window.removeEventListener('keydown', close)
        }, [])

        const handleGetTerms = (type, date) => {
        if (date.date_to != null && date.date_to != '' && date.date_to != 'Invalid date') {
            getGrantsTerms(type, date);
        }
    }
  
        const handleChange = (level, target, element) => {
                const {name, value} = target;
                let date_from;
                if (element.prep_struc_category == 'Курсант') {
                    date_from = moment(value).subtract(2, 'year').format(dateFormat);
                } else if (element.prep_struc_category == 'Слушатель') {
                    date_from = moment(value).subtract(1, 'year').format(dateFormat);
                } else if (element.prep_struc_category == 'Адъюнкт') {
                    date_from = moment(value).subtract(1, 'year').format(dateFormat);
                } else if (element.prep_struc_category == 'СПО') {
                    date_from = moment(value).subtract(1.5, 'year').format(dateFormat);
                }
        
                const _date_from = moment(date_from).set('date', 1).set('month', 8).format(dateFormat);
                const newOptionsLocal = [...optionsLocal];
                newOptionsLocal[level][name] = value;
                newOptionsLocal[level].date_from = _date_from;
        
                handleGetTerms(element.id, {
                    date_from: newOptionsLocal[level].date_from,
                    date_to: newOptionsLocal[level].date_to});
        
                setOptionsLocal(newOptionsLocal);
            };

    
        const handleSaveTerms = () => {
            setIsTermPopup(null)
        }
    
        const handleChangeTerms = (id, trmid) => {
            setOptionsLocal(prev => 
                prev.map(options => options.id === id ? {...options, 
                    'trmids': options.trmids.map(el => el.trmid == trmid ? ({...el, isChecked: !el.isChecked}) : el)
                
                } : options
            ))
        };

        const handleCheckDate = (date) => {
            if (date != null && date != '' && date != 'Invalid date') {
                return false;
            } else {
                return true;
            }
        }
    
        const handleIsTermPopup = (index, element) => {
            if (handleCheckDate(element.date_to)) {
                createNotification('error', 'Заполните поле "Дата до"');
            } else {
                getGrantsTerms(element.id, {date_to: element.date_to});
                setIsTermPopup(index);
            }
        }
        
    const handleReset = () => {
            // store.dispatch({type: SET_SCHOLARSHIP_SETTINGS, payload: null});
            // store.dispatch({type: SET_SCHOLARSHIP_LEVELS, payload: null});    
    }

    const handleChangeOptions = (id, param_name, e) => {
    const newValue = e.target.textContent; // или innerHTML, если нужны теги

    const newOptionsLocal = optionsLocal.map(item =>
        item.id === id
        ? { ...item, [param_name]: Number(newValue) || null  }
        : item
    );

    setOptionsLocal(newOptionsLocal);
    };

    useEffect(() => {
            if (Object.keys(terms).length === 0) {
                return;
            }
        const newOptions = optionsLocal?.map(item => {
        if (typeof terms?.type === String && terms?.type?.startsWith('id-')) {
            // Обрабатываем случай, когда тип начинается с 'id-'
            return {
            ...item,
            trmids: [
                // Оставляем существующие, которые есть в terms.date
                ...(item.trmids?.filter(existing =>
                terms.date.some(t => t.trmid === existing.trmid)
                ) || []),
                // Добавляем новые, которых ещё нет
                ...terms.date
                .filter(t => !item.trmids?.some(existing => existing.trmid === t.trmid))
                .map(t => ({ ...t, isChecked: false }))
            ]
            };
        } else {
            // Если item.id совпадает с terms.type — обновляем trmids
            if (item.id == terms.type) {
            return {
                ...item,
                trmids: [
                // Оставляем те, что уже есть и присутствуют в terms.date
                ...(item.trmids?.filter(existing =>
                    terms.date.some(t => t.trmid === existing.trmid)
                ) || []),
                // Добавляем новые
                ...terms.date
                    .filter(t => !item.trmids?.some(existing => existing.trmid === t.trmid))
                    .map(t => ({ ...t, isChecked: false }))
                ]
            };
            } else {
            // Возвращаем item без изменений
            return item;
            }
        }

            }
            );
        
            setOptionsLocal(newOptions);
        }, [terms]);

    useEffect(() => {
            if (scholarshipSettings == null) {
                return;
            }
            const newOptions = scholarshipLevels?.map((opt, index) => {
                let finded = scholarshipSettings?.find(tr => tr.education_level == opt.education_level && tr.prep_struc_category_id == opt.prep_struc_category_id);
                return ({
                ...opt,
                ...finded,
                trmids: finded?.trmids?.map(tr => ({...tr, isChecked: true})),
                id: finded?.id ? finded?.id : `id-${Date.now() + index}` 
            })
        }
        )
    
            setOptionsLocal(newOptions);
        }, [scholarshipLevels, scholarshipSettings])

    return (
    <div className={styles.popup}>
            <div className={styles.wrapper}>
                <p className={styles.title}>Настройки параметров для видов стипендий
                    <div className={styles.selector}>
                    <Selector
                        label=''
                        width='300px'
                        options={[...yearsLocal]}
                        onChange={(e) => setYear(e)}
                        value={year}/>
                    </div>
                    </p>
                    <div className={styles.button + ' ' + styles.reset} onClick={handleReset}>Сброс</div>
                    <Loader loaded={!scholarshipLevelsLoading} color='grey'>
                    <div className={styles.tableWrapper}>
                    {year !== '0' ? <table className={styles.table}>
                         <thead>
                            <tr>
                            <th rowspan="2">Уровень<br/>образования</th>

                            <th rowspan="2">Курс с которого<br/>назначается<br/>стипендия</th>

                            <th rowspan="2">Период<br/>промежуточной<br/>аттестации</th>

                            <th colspan="2">Средний балл по<br/>промежуточной аттестации</th>

                            <th colspan="2">Период достижений</th>

                            <th rowspan="2">Минимальное<br/>количество<br/>достижений</th>
                            </tr>

                            <tr>
                            <th>Минимальный</th>
                            <th>Максимальный</th>

                            <th>Дата начала</th>
                            <th>Дата окончания</th>
                            </tr>
                        </thead>
                        <tbody>
                            {optionsLocal?.map((element, index) => 
                            <tr key={index}>
                                
                            <td
                                style={{
                                    fontWeight: '700'
                                }}>{educationLevelsReNames[element.prep_struc_category]}</td>
                            <td 
                                contenteditable="true"
                                suppressContentEditableWarning={true} 
                                onInput={(e) => 
                                handleChangeOptions(element.id, 'course_from', e)}>{element.course_from}</td>
                            <td
                                style={{
                                width: '40%',
                                position: 'relative'
                            }}>
                                {element.trmids?.filter(trm => trm.isChecked)
                                ?.map((item, index) => index !== 0 ? ', ' + item.title : item.title)}
                                        {isTermPopup == index+1 ? (
                                    <div className={styles.termsPopup}>
                                        <div className={styles.termsPopupInner}>
                                            {element.trmids
                                                ?.map(({title, trmid, isChecked}) => 
                                                <div 
                                                    className={styles.termsPopupItem} 
                                                    key={trmid}
                                                    onClick={(e) => handleChangeTerms(element.id, trmid)}
                                                    >
                                                    <input
                                                        type="checkbox"
                                                        name="trmids"
                                                        checked={isChecked}
                                                        value={trmid}/> {title}
                                                </div>)
}
                                        </div>

                                        <div className={styles.termsPopupBtns}>
                                            <div className={styles.termsPopupBtn} onClick={handleSaveTerms}>Ок</div>
                                        </div>
                                    </div>
                                ): null}
                                <div onClick={() => handleIsTermPopup(index+1, element)} className={styles.termsBtn}>Изменить</div>
                            </td>

                            <td 
                                contenteditable="true"
                                suppressContentEditableWarning={true} 
                                onInput={(e) => 
                                handleChangeOptions(element.id, 'average_grade', e)}>{element.average_grade}</td>
                            <td 
                                contenteditable="true"
                                suppressContentEditableWarning={true} 
                                onInput={(e) => 
                                handleChangeOptions(element.id, 'max_average_grade', e)}>{element.max_average_grade}</td>

                            <td style={{backgroundColor: '#c5c5c5'}}>
                                <input
                                style={{backgroundColor: '#c5c5c5'}}
                                disabled
                                value={moment(element?.date_from).format(dateFormat)}
                                type="date"
                                name='date_from'
                                className={styles.inputDateFrom}
                                /></td>
                            <td><input
                                value={moment(element?.date_to).format(dateFormat)}
                                type="date"
                                name='date_to'
                                className={styles.inputDateTo}
                                onChange={(e) => handleChange(index, e.target, element)}
                                /></td>
                            <td 
                                contenteditable="true"
                                suppressContentEditableWarning={true} 
                                onInput={(e) => 
                                handleChangeOptions(element.id, 'min_achievements', e)}>{element.min_achievements}</td>
                        </tr>
                            )}
                        </tbody>
                    </table> : <></>}
                    </div>
                </Loader>
                {/* </div> */}

                


                <div className={styles.buttons}>
                    <div className={styles.buttonClose} onClick={handleClose}>Закрыть</div>
                    <div className={styles.button} onClick={handleSubmit}>Сохранить</div>
                </div>
            </div>
    </div>
  )
}

export default connect(mapStateToProps, {getScholarshipSettings, getGrantsYears, getScholarshipLevels, getGrantsTerms, editGrantsOptions, addScholarshipSettings, editScholarshipSettings, getScholarshipTree})(Index)